export default __webpack_public_path__ + "static/media/icon_queued.f000aa85.svg";